import Typography from "components/elements/Typography";
import Button, { EButtonColor, EButtonSize, EButtonVariant } from "components/elements/Button";

type IProps = {
	email: string;
	label: string;
};

export default function ContactButton(props: IProps) {
	return (
		<a href={`mailto:${props.email}`}>
			<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} size={EButtonSize.MEDIUM}>
				<Typography type="span" size="medium" weight="medium">
					{props.label}
				</Typography>
			</Button>
		</a>
	);
}
